import { useConfirmDialog } from '@ztechapps/common.hook'
import { useDeleteTaskSubTasks } from '@ztechapps/task.common'

export const useDeleteTaskSubTaskWithConfirm = (taskId: string) => {
  const [onDeleteTask, { error, loading }] = useDeleteTaskSubTasks()
  const { onConfirm } = useConfirmDialog({
    text: `Are you sure you remove the selected task(s)?`,
    title: 'Remove task?',
    buttons: { confirm: { text: 'Yes, remove it!' } },
    confirmed: async (subTaskIds: string[]) => {
      await onDeleteTask({
        taskId,
        subTaskIds,
      })
    },
  })

  return {
    onDelete: onConfirm,
    error,
    loading,
  }
}
